import { loadConfig } from './Config';

// Initialize configuration before loading the main application
loadConfig().then(() => {
  // We use require or dynamic import to load the main app module
  // equivalent to importing './main' but strictly after promise resolution
  import('./main');
}).catch(err => {
  console.error('Failed to initialize application configuration:', err);
});
